import React from "react";

const Opciones = ({ opcion, setOpcion }) => {
	const Handler = (event) => {
		setOpcion(event.target.name);
	};

	return (
		<div className='button-group-container'>
			<a
				className={
					opcion == "Poder SII" ? "button primary" : "button secondary hollow"
				}
				name='Poder SII'
				style={{ borderRadius: "10px" }}
				onClick={(e) => Handler(e)}
			>
				Poder SII
			</a>
			<a
				className={
					opcion == "Poder Municipal" ? "button primary" : "button secondary hollow"
				}
				name='Poder Municipal'
				style={{ borderRadius: "10px" }}
				onClick={(e) => Handler(e)}
			>
				Poder Muni
			</a>
			<a
				className={
					opcion == "Contrato Arriendo Mensual"
						? "button primary"
						: "button secondary hollow"
				}
				name='Contrato Arriendo Mensual'
				style={{ borderRadius: "10px" }}
				onClick={(e) => Handler(e)}
			>
				Dt Mensual
			</a>
			<a
				className={
					opcion == "Contrato Arriendo Anual"
						? "button primary"
						: "button secondary hollow"
				}
				name='Contrato Arriendo Anual'
				style={{ borderRadius: "10px" }}
				onClick={(e) => Handler(e)}
			>
				Dt Anual
			</a>
			<a
				className={
					opcion == "Contrato Arriendo 30 dias"
						? "button primary"
						: "button secondary hollow"
				}
				name='Contrato Arriendo 30 dias'
				style={{ borderRadius: "10px" }}
				onClick={(e) => Handler(e)}
			>
				Dt 30 dias
			</a>
			<a
				className={
					opcion == "Contrato Contabilidad"
						? "button primary"
						: "button secondary hollow"
				}
				name='Contrato Contabilidad'
				style={{ borderRadius: "10px" }}	
				onClick={(e) => Handler(e)}
			>
				Contrato Conta.
			</a>
			<a
				className={
					opcion == "Conta Persona Natural"
						? "button primary"
						: "button secondary hollow"
				}
				name='Conta Persona Natural'
				style={{ borderRadius: "10px" }}
				onClick={(e) => Handler(e)}
			>
				Conta P. Natural
			</a>
			<a
				className={
					opcion == "Documentos Patente"
						? "button primary"
						: "button secondary hollow"
				}
				name='Documentos Patente'
				style={{ borderRadius: "10px" }}
				onClick={(e) => Handler(e)}
			>
				Doc. Patente
			</a>
			<a
				className={
					opcion == "Contrato Bodega"
						? "button primary"
						: "button secondary hollow"
				}
				name='Contrato Bodega'
				style={{ borderRadius: "10px" }}
				onClick={(e) => Handler(e)}
			>
				Contrato Bodega
			</a>
		</div>
	);
};

export default Opciones;
